export default __webpack_public_path__ + "static/media/Venus.e0dbb95c.jpg";